// repo: https://vuemc.io/#basic-usage
import {Model, Collection} from 'vue-mc'
import isPresent from 'is-present'
import {Section} from "./section";
import {Registration} from "./registration";

class RegistrationSection extends Model {
  defaults() {
    return {
      id: null,
      price: {},
      section: {},
      registration: {},
      _destroy: false,
    }
  }
  mutations() {
    return {
      id:   (id) => Number(id) || null,
      section: (json)=>{ return new Section(json)},
    }
  }
  checked(){
    // we need this specifically for auto-selecting section if there's only 1 section on a program.
    return (this.registration.isStillPending() && this.registration.program.sections.length === 1) || !this._destroy
  }

  invalid(){
    return this.age_invalid || this.grade_invalid
  }
}

export {
  RegistrationSection
}